import React, { Component } from "react";
import { Route, Router } from "react-router-dom";
import { connect } from "react-redux";

import "./App.css";

import { history } from "./_helpers";
import { alertActions } from "./_actions";
import { PrivateRoute } from "./_components";
import { HomePage } from "./HomePage";
import { LoginPage } from "./LoginPage";
import { VerifyAccountPage } from "./VerifyAccountPage";
import { SnackBar } from "./SnackBar";
import { FullScreenDialog } from "./Dialog";
import { AddCampaignPage } from "./AddCampaignPage";
import { CampaignDetailPage } from "./CampaignDetailPage";
import { CampaignDetailCharts } from "./CampaignDetailCharts";
import { ProfilePage } from "./ProfilePage";
import { gbConstants } from "./_constants";

class App extends Component {
    constructor(props) {
        super(props);

        const { dispatch } = this.props;
        history.listen((location, action) => {
            // clear alert on location change
            dispatch(alertActions.clear());
        });
    }

    render() {
        var snackBar_autoHideDuration = null;
        var snackBar_showCloseBtn = true;
        var snackBar_tapOutsideToClose = true;
        if (this.props.alert) {
            snackBar_autoHideDuration =
                this.props.alert.autoHide === null ||
                this.props.alert.autoHide === undefined ||
                this.props.alert.autoHide === true
                    ? 2000
                    : null;

            snackBar_showCloseBtn =
                this.props.alert.showCloseBtn != null &&
                !this.props.alert.showCloseBtn
                    ? this.props.alert.showCloseBtn
                    : true;

            snackBar_tapOutsideToClose =
                this.props.alert.tapOutsideToClose != null &&
                !this.props.alert.tapOutsideToClose
                    ? this.props.alert.tapOutsideToClose
                    : true;
        }
        return (
            <div>
                <SnackBar
                    showCloseBtn={snackBar_showCloseBtn}
                    autoHideDuration={snackBar_autoHideDuration}
                    tapOutsideToClose={snackBar_tapOutsideToClose}
                />
                <FullScreenDialog />
                <Router history={history}>
                    <div>
                        <PrivateRoute
                            exact
                            path={gbConstants.PATH_ROOT}
                            component={HomePage}
                        />
                        <PrivateRoute
                            exact
                            path={gbConstants.PATH_VERIFY_ACCOUNT}
                            component={VerifyAccountPage}
                        />
                        <PrivateRoute
                            exact
                            path={gbConstants.PATH_CREATE_CAMPAIGN}
                            component={AddCampaignPage}
                        />
                        <PrivateRoute
                            exact
                            path={gbConstants.PATH_CAMPAIGN_DETAIL}
                            component={CampaignDetailPage}
                        />
                        <PrivateRoute
                            exact
                            path={gbConstants.PATH_CHART_DETAIL}
                            component={CampaignDetailCharts}
                        />
                        <PrivateRoute
                            exact
                            path={gbConstants.PATH_PROFILE}
                            component={ProfilePage}
                        />
                        <Route
                            path={gbConstants.PATH_LOGIN}
                            component={LoginPage}
                        />
                    </div>
                </Router>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert
    };
}

const connectedApp = connect(mapStateToProps)(App);

export default connectedApp;



// WEBPACK FOOTER //
// ./src/App.js